import { render, staticRenderFns } from "./tDesktop.vue?vue&type=template&id=69cca56a&"
import script from "./tDesktop.vue?vue&type=script&lang=ts&"
export * from "./tDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./tDesktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports